import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

export function LoadingPage() {
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const timer = setTimeout(() => {
      setShowAnimation(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gradient-to-b from-sky-100 to-indigo-200/80">
      <div
        className={cn(
          `h-[400px] w-[600px]`,
          showAnimation ? 'opacity-100' : 'opacity-0'
        )}
      >
        <DotLottieReact
          src="https://lottie.host/b8da63b3-419d-4221-b478-c6799b3f5fbe/EZWyWNZClU.lottie"
          loop
          autoplay
        />
      </div>
    </div>
  );
}
